import axios from "axios";
import { API_URL } from "./utils";
import { openPdfDocument } from "./docViewer";

export const fetchSessionReport = async (sessionId, headers) =>
  (await axios.get(`${API_URL}/cash/sessions/${sessionId}/report`, { headers, withCredentials: true })).data;

export const fetchSessionPdf = async (sessionId, headers) => {
  const r = await axios.get(`${API_URL}/cash/sessions/${sessionId}/report.pdf`, { headers, withCredentials: true, responseType: "blob" });
  return new Blob([r.data], { type: "application/pdf" });
};

export const downloadBlob = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url; a.download = filename;
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 15000);
};

export const printBlob = (blob, filename = "relatorio_caixa.pdf") => openPdfDocument(blob, { title: "Relatório de caixa", filename, autoPrint: true });

export const openBlob = (blob, filename = "relatorio_caixa.pdf") => openPdfDocument(blob, { title: "Relatório de caixa", filename });
